import { useState, useEffect } from 'react';
import { featureToggleServiceInstance } from '@/common/config/FeatureToggleService';

declare global {
    interface Window {
        featureToggles?: Record<string, boolean>;
    }
}

export const FEATURE_TOGGLES_UPDATED_EVENT = 'featureTogglesUpdated';

export const notifyFeatureTogglesUpdated = () => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(FEATURE_TOGGLES_UPDATED_EVENT, {
            detail: { toggles: window.featureToggles }
        }));
    }
};

export const useFeatureFlag = (key: string): boolean => {
    const getCurrentValue = () => {
        return featureToggleServiceInstance.isEnabled(key);
    };

    const [enabled, setEnabled] = useState<boolean>(getCurrentValue());

    useEffect(() => {
        const handleUpdate = () => {
            const newValue = getCurrentValue();
            setEnabled(newValue);
        };

        handleUpdate();

        window.addEventListener(FEATURE_TOGGLES_UPDATED_EVENT, handleUpdate);

        return () => {
            window.removeEventListener(FEATURE_TOGGLES_UPDATED_EVENT, handleUpdate);
        };
    }, [key]);

    return enabled;
};